export const menuArr = [
  { type: 'link', to: '/', label: '首页', activeNames: ['newIndex', 'index'] },
  { type: 'link', to: '/bountyRecruitment', label: '悬赏招聘', activeNames: ['bountyRecruitment'] },
  {
    type: 'dropdown',
    label: '产品中心',
    children: [
      { command: '/talent-management', label: 'InterviewAI',value:'AI 面试' },
      { command: '/interview', label: 'TalentHub',value:'人才管理' },
      { command: '/employment', label: 'JobCabin',value:'就业舱' },
      { command: '/offerBot', label: 'OfferBot',value:'求职助理' },
    ]
  },
  { type: 'link', to: '/cooperation', label: '对外合作', activeNames: ['cooperation'] },
  { type: 'link', to: '/news', label: '新闻中心', activeNames: ['news', 'newsdetails', 'newsdeil'] },
  { type: 'link', to: '/about-us', label: '关于我们', activeNames: ['about-us'] }
]

export const routerList = {
  'newIndex': 'page_home_view',
  'index': 'page_home_view',
  'bountyRecruitment': 'page_bounty_recruitment_view',
  'cooperation': 'page_cooperation_view',
  'employment': 'page_employment_view',
  'talent-management': 'page_talent_management_view',
  'talent': 'page_talent_management_view',
  'interview': 'page_interview_view',
  'example': 'page_example_view',
  'news': 'page_news_view',
  'newsdetails': 'page_news_view',
  'newsdeil': 'page_news_view',
  'about-us': 'page_about_us_view',
}
